import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

const FORM_ID = 'createCustomerAccountForm';

export default class CreateCustomerAccountForm extends React.Component {
  static propTypes = {
    createAccountFunction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    securityToken: PropTypes.string,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    securityToken: '',
  };

  constructor(props) {
    super(props);
    this.createAccount = this.createAccount.bind(this);
  }

  createAccount = evt => {
    const { createAccountFunction, securityToken } = this.props;
    createAccountFunction(securityToken, evt);
  };

  render() {
    /* IMPORTANT NOTE: WILL ADD NAME FIELDS LATER (AND POSSIBLY EMAIL) COMMENTING OUT FOR NOW */
    const { invalid, handleSubmit, submitting } = this.props;

    return (
      <Form id={FORM_ID} className="padded-form" onSubmit={handleSubmit(this.createAccount)}>
        <fieldset>
          {/* <div className="form-group no-inner-margin">
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <Field
                  name="firstName"
                  type="text"
                  component={ InputField }
                  label="First Name"
                  placeholder="First name"
                  autoFocus
                />
              </div>
              <div className="col-xs-12 col-md-6">
                <Field
                  name="lastName"
                  type="text"
                  component={ InputField }
                  label="Last Name"
                  placeholder="Last name"
                />
              </div>
            </div>
          </div>
          <Field
            name="email"
            type="text"
            component={ InputField }
            label="Email"
            placeholder="email"
          /> */}
          <Field
            name="password"
            type="password"
            component={InputField}
            label="Password"
            placeholder="your password"
            autoFocus
          />
          <Field
            name="confirmPassword"
            type="password"
            component={InputField}
            label="Confirm Password"
            placeholder="confirm password"
          />
        </fieldset>
        <p className="pull-right">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={checkButtonDisabled(invalid, submitting)}
          >
            Create Account
          </button>
        </p>
      </Form>
    );
  }
}
